import { openAuthSessionAsync } from 'expo-web-browser';

import { idMeConfig } from '../../config';
import { type IdMeSignOutResult } from '../../idme.types';

// ─────────────────────────────────────────────────────────────────────────────

export async function signOutOfIdMe(): Promise<IdMeSignOutResult> {
  const { clientId, redirectUri, logoutEndpoint } = idMeConfig;

  const query = new URLSearchParams({ client_id: clientId, redirect_uri: redirectUri });
  const response = await openAuthSessionAsync(`${logoutEndpoint}?${query}`, redirectUri);

  const isSignedOut = response.type === 'success';

  return { status: isSignedOut ? 'signed_out' : 'cancelled' };
}
